export enum MessageCode {
    /** 无权限查看 */
    NOT_PRIVILEGE_VIEW = '110000',
    /** 销售加价规则六轴判重冲突。 */
    SALES_INCREASE_RULES_CONFLICT = '210174',
}
